"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlagList = FlagList;
const react_1 = require("react");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_2 = require("react");
const prop_types_1 = __importDefault(require("prop-types"));
const Flag_1 = require("../Flag/Flag");
const FlagList_module_scss_1 = __importDefault(require("./FlagList.module.scss"));
const sortFlags = (flagA, flagB) => {
    if (flagA.isExperiment && !flagB.isExperiment) {
        return -1;
    }
    if (!flagA.isExperiment && flagB.isExperiment) {
        return 1;
    }
    return 0;
};
function FlagList({ flags, setFlagValue, overrides }) {
    const [searchTerm, setSearchTerm] = (0, react_2.useState)('');
    const [selectedFilter, setSelectedFilter] = (0, react_2.useState)('ALL');
    let filteredFlags = [...flags].filter(({ tags }) => !tags.some(value => value === 'mock' || value === 'template'));
    if (searchTerm) {
        filteredFlags = filteredFlags.filter(({ description, flagKey, tags, name }) => {
            return [description, flagKey, name, ...tags].map((flagValue) => {
                return searchTerm.split(' ').every((searchToken) => {
                    return flagValue.toLowerCase().includes(searchToken.toLowerCase());
                });
            }).some(Boolean);
        });
    }
    if (selectedFilter !== 'ALL') {
        filteredFlags = filteredFlags.filter(({ isExperiment }) => {
            if (selectedFilter === 'EXPERIMENTS') {
                return isExperiment;
            }
            return !isExperiment;
        });
    }
    const flagList = [...filteredFlags];
    return ((0, jsx_runtime_1.jsxs)("div", { className: FlagList_module_scss_1.default.container, children: [(0, jsx_runtime_1.jsxs)("div", { className: FlagList_module_scss_1.default.searchContainer, children: [(0, jsx_runtime_1.jsx)("input", { type: "text", placeholder: 'search', onChange: (e) => setSearchTerm(e.target.value), className: FlagList_module_scss_1.default.search }), (0, jsx_runtime_1.jsxs)("select", { name: 'filter', "aria-label": 'Filter selector', value: selectedFilter, className: FlagList_module_scss_1.default.select, onChange: (e) => setSelectedFilter(e.target.value), children: [(0, jsx_runtime_1.jsx)("option", { value: 'ALL', children: "Show All" }), (0, jsx_runtime_1.jsx)("option", { value: 'EXPERIMENTS', children: "Experiments" }), (0, jsx_runtime_1.jsx)("option", { value: 'FEATURES', children: "Features" })] })] }), (0, jsx_runtime_1.jsx)("ul", { children: flagList.sort(sortFlags).map((flag) => {
                    const otherInfo = flag.splits.length ? [flag.splits.join('/')] : null;
                    return (0, react_1.createElement)(Flag_1.Flag, { ...flag, otherInfo: otherInfo, setFlagValue: setFlagValue, overrides: overrides, key: flag.flagKey });
                }) })] }));
}
FlagList.propTypes = {
    flags: prop_types_1.default.arrayOf(prop_types_1.default.shape({
        /** the flag key */
        flagKey: prop_types_1.default.string.isRequired,
        /** the flag name */
        name: prop_types_1.default.string,
        /** the default value when targeting is "off" */
        defaultOffValue: prop_types_1.default.oneOfType([prop_types_1.default.number, prop_types_1.default.string, prop_types_1.default.bool]).isRequired,
        /** the current flag value */
        currentValue: prop_types_1.default.oneOfType([prop_types_1.default.number, prop_types_1.default.string, prop_types_1.default.bool]).isRequired,
        /** the initial flag value a user was assigned (before overrides) */
        initialValue: prop_types_1.default.oneOfType([prop_types_1.default.number, prop_types_1.default.string, prop_types_1.default.bool]).isRequired,
        /** the possible values for the flag */
        valueOptions: prop_types_1.default.arrayOf(prop_types_1.default.oneOfType([prop_types_1.default.number, prop_types_1.default.string, prop_types_1.default.bool])).isRequired,
        /** an array of other info to be displayed for the flag */
        otherInfo: prop_types_1.default.arrayOf(prop_types_1.default.string),
        /** the url for the ticket in jira  */
        jiraUrl: prop_types_1.default.string,
        /** a url for the feature flag in the launch darkly dashboard */
        launchDarklyUrl: prop_types_1.default.string.isRequired,
        /** jira ticket attached to feature flag key */
        jiraTicket: prop_types_1.default.string,
        /** description of feature flag set in launch darkly */
        description: prop_types_1.default.string,
        /** boolean that tells if this flag is a feature flag */
        isFeatureFlag: prop_types_1.default.bool
    })),
    /** a function to set the new override for a flag */
    setFlagValue: prop_types_1.default.func.isRequired,
    /** overrides that have been selected in the widget  */
    overrides: prop_types_1.default.objectOf(prop_types_1.default.oneOfType([prop_types_1.default.number, prop_types_1.default.string, prop_types_1.default.bool])).isRequired
};
//# sourceMappingURL=FlagList.js.map